import React from "react";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import "./styles.scss";

const PetrolPrices = ({ sectionClasses }) => {
  const prices = [
    { name: "MS (Petrol)", old: 257.13, new: 256.139, diff: '-1.00' },
    { name: "High Speed Diesel (HSD)", old:  267.95, new: 263.95, diff: '-4.00' },
    { name: "Kerosene (SKO)", old: 174.06, new: 171.65, diff: '-3.20' },
    { name: "Light Diesel Oil", old: 161.06, new: 155.81, diff: '-' },
  ];

  return (
    <section className={`section-padding ${sectionClasses}`}>
      <div className="container">
        <div id="petrol-prices">
          <h1 className="text-primary mb-5">Petrol Prices in Pakistan</h1>
          <div className="container">
            <div className="row">
              <div className="col-sm-3 col-4 px-sm-3 px-1 border-bottom border-dark py-2">
                <h3 className="text-left">FUEL TYPES</h3>
              </div>
              <div className="col-sm-3 col-4 px-sm-3 px-1 border-bottom border-dark py-2">
                <h3 className="d-flex justify-content-center">
                  OLD <span className="d-none d-sm-block ml-2">PRICE</span>
                </h3>
              </div>
              <div className="col-sm-3 col-4 px-sm-3 px-1 border-bottom border-white py-2 bg-primary">
                <h3>NEW</h3>
                <small>w.e.f 16-February-2025</small>
              </div>
              <div className="col-sm-3 d-none d-sm-block border-bottom border-dark py-2">
                <h3>DIFFERENCE</h3>
              </div>
            </div>
            {prices &&
              prices.map((price, i) => (
                <div className="row border-bottom border-dark" key={i}>
                  <div className="col-sm-3 col-4 px-sm-3 px-1">
                    <p className="text-left">{price.name}</p>
                  </div>
                  <div className="col-sm-3 col-4 px-sm-3 px-1">
                    <p>{price.old}</p>
                  </div>
                  <div className="col-sm-3 col-4 px-sm-3 px-1 bg-primary border-bottom border-white">
                    <p>{price.new}</p>
                  </div>
                  <div className="col-sm-3 d-none d-sm-block">
                    <p>
                      {price.diff}
                    </p>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PetrolPrices;
